import { PayloadAction, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { logoutWithDelay } from 'store/oauth/service';

import { getTasks, getTasksForTemplate } from './service';

export const initialState: ITasksState = {
  filters: [],
  data: [],
  loading: false,
  error: false
};

const slice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<ITemplatePageFilters[]>) => {
      state.filters = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutWithDelay.fulfilled, () => initialState)
      .addMatcher(isAnyOf(getTasks.pending, getTasksForTemplate.pending), (state) => {
        state.loading = true;
        state.error = false;
      })
      .addMatcher(isAnyOf(getTasks.rejected, getTasksForTemplate.rejected), (state) => {
        state.loading = false;
        state.error = true;
      })
      .addMatcher(isAnyOf(getTasks.fulfilled, getTasksForTemplate.fulfilled), (state, action) => {
        state.loading = false;
        state.error = false;
        state.data = action.payload;
      });
  }
});

export const { updateFilters } = slice.actions;
export const tasksReducer = slice.reducer;
